<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      class="term"
      v-model="value"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="onShowTermPicker"
    />
    <van-popup v-model="showTermPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsTerm"
        @cancel="showTermPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>
    <div class="term">
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelfSelect',
  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    defaultValue: {
      default: '',
    },
    columnsTerm: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTermPicker: false,
      value: '',
    };
  },

  methods: {
    onConfirm(val) {
      this.$emit('input', val.value);
      this.value = val.text;
      this.showTermPicker = false;
    },
    onShowTermPicker () {
      if (this.disabled) {
        return
      }
      this.showTermPicker = true
    }
  },
  watch: {
    defaultValue: {
      handler(val) {
        if (!val) return;
        const filterResult = this.columnsTerm.filter((item) => (item.value === val));
        if (filterResult.length === 0) return;
        console.log(filterResult);
        this.value = filterResult[0].text;
        this.$emit('input', val);
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
>>>.van-field__label {
  text-align: left;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #1c2438;
  width: 129px!important;
  margin-right: 0px !important;
}
.term::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #DDDEE1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
>>>.van-picker__cancel, >>>.van-picker__confirm{
  color: #FF6538;
}
 >>> .van-field__control::-webkit-input-placeholder{
color: #828282;
}

>>> .van-field__control::-moz-input-placeholder{
color: #828282;
}

>>> .van-field__control::-ms-input-placeholder{
color: #828282;

}
</style>
